
import { ModalDetalheAgronomoProvider } from "../ModalDetalheAgronomoContext";
import Listagem from "./Listagem";

export default function ListarTodos() {
    return (
        <>
            <ModalDetalheAgronomoProvider>
                <Listagem />
            </ModalDetalheAgronomoProvider>
        </>
    )
}

